// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3662":"364f6a20","9377":"301a93a0"}[chunkId] + ".chunk.css";
};